

export function findPermissionTab(array, name) {
    return array?.find((element) => {
        return element?.resource?.name === name;
    })
}

export function findArrayElementById(array, _id) {
    return array.find((element) => {
        return element._id === _id;
    })
}